import * as d3 from "d3";
import {
    blueScheme,
    colonAnnotation, contextMenu,
    createTooltip,
    DEFAULT_AXIS_FONT_SIZE,
    DEFAULT_AXIS_LABEL_FONT_SIZE,
    generateDownloadData,
    numberFormat,
    responsivefy
} from '../functions'

export default function (chart, divId, vizName,resData, filterParam) {
    const defaultSize = true
    const defaultChartLayout = {
        width: 1000,
        height: 500,
        margin: { top: 40, right: 280, bottom: 100, left: 120 }
    }
    const chartWidth = defaultSize ? defaultChartLayout.width : chart.width
    const chartHeight = defaultSize ? defaultChartLayout.height : chart.height
    const chartMargin = defaultSize ? defaultChartLayout.margin : chart.margin

    const axisTickFontPx = defaultSize ? DEFAULT_AXIS_FONT_SIZE : chart.axisFontSize
    var axisfontsize = axisTickFontPx + 'px'
    var axislabelfontsize = (defaultSize ? DEFAULT_AXIS_LABEL_FONT_SIZE : chart.axisLabelFontSize) + 'px'
    var axislabelfontcolor = chart.axisLabelFontColor
    var axisfontcolor = chart.axisFontColor
    //var tempVar = chart.tempVar
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName,filterParam)
    console.log("Chart called:", chart)

    // axios.post(url, filterParam).then(res => {
        let data = resData
        var x1Scale = d3.scaleLinear().range([0, chartWidth])
        var y1Scale = d3.scaleBand().rangeRound([chartHeight, 0]).padding(0.1)
        var metric1ColorScale = d3.scaleOrdinal(blueScheme)
        var x1AxisLabel = d3.axisBottom(x1Scale).ticks(9).tickFormat(numberFormat)
        var y1AxisLabel = d3.axisLeft(y1Scale)

        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId)
            .append('svg')
            .attr('width', chartWidth + chartMargin.left + chartMargin.right)
            .attr('height', chartHeight + chartMargin.top + chartMargin.bottom)
            .call(responsivefy)
            .append('g')
            .attr('transform', 'translate(' + chartMargin.left + ',' + chartMargin.top + ')')

        metric1ColorScale.domain(d3.keys(data[0]).filter((key) => {
            return key !== 'colorClass'
        }))

        data.forEach(function (d) {
            var y0 = 0
            d.values = metric1ColorScale.domain().map(function (name) {
                return {name: name, y0: y0, y1: y0 += +d[name]}
            })
            d.total = d.values[d.values.length - 1].y1
        })

        x1Scale.domain([0, d3.max(data, d => {
            return d.total
        })])
        y1Scale.domain(data.map(d => {
            return d.colorClass
        }))

        svg.append('g')
            .attr('class', 'x axis')
            .attr('transform', 'translate(0,' + chartHeight + ')')
            .call(x1AxisLabel)
            .selectAll('text')
            .style('font-size', axisfontsize)
            .style('fill', axisfontcolor)

        svg.append('g')
            .attr('class', 'y axis')
            .call(y1AxisLabel)
            .style('font-size', axisfontsize)
            .append('text')
            .attr('transform', 'rotate(-90)')
            .style('fill', axislabelfontcolor)
            .style('font-size', axisfontsize)
            .style('text-anchor', 'end')

        /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element
            var y1tip = d3.select(divId).append('tip').attr('class', 'd3-tip'+divId.id)*/

        // d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        // var div = d3.select(divId).append('div').attr('class', 'tooltip')
        //     .attr('style', 'position: absolute; opacity: 0;')

        const tooltip = createTooltip(divId);

        var bar = svg.selectAll('.bar')
            .data(data)
            .enter()
            .append('g')
            .attr('class', 'g')
            .attr('transform', d => {
                return 'translate(0, ' + y1Scale(d.colorClass) + ')'
            })
            .on('mouseover', function(event, d) {
                console.log(event, d)
                var elements = document.querySelectorAll(':hover')
                var len = elements.length
                len = len - 1
                var element = elements[len].__data__
                var value = element.y1 - element.y0

                if (element.name === 'metric1') {
                    element.name = chart.y1MetricTooltip
                } else if (element.name === 'metric2') {
                    element.name = chart.y2MetricTooltip
                } else if (element.name === 'metric3') {
                    element.name = chart.x1MetricTooltip
                }

                tooltip.onMouseOver(d, this, function(d) {
                    console.log(event, d)
                    // Tooltip content callback
                    return  element.name + colonAnnotation + numberFormat(value);
                });  // Pass the event for positioning
            })
            .on('mousemove', function(event) {
                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
            })
            .on('mouseout', function() {
                tooltip.onMouseLeave();  // Hide the tooltip on mouse leave
            })
            .on('contextmenu', function(event, d) {
                console.log(d);
                // Prepare clickedData with both axes' info
                const clickedData = {};
                // Generate the menu with current config and filters
                const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                // Show the context menu
                contextMenu(menuItems).call(this, clickedData);

                // Prevent default context menu
                event.preventDefault();
            });
        /*.on('mouseover', () =>{
                    y1tip.transition()
                        .duration(500)
                        .style('line-height', '1')
                        .style('padding', '12px')
                        .style('background', 'white')
                        .style('border-radius', '5px')
                        .style('position', 'absolute')
                        .style('border-width', '.1px')
                        .style('border-style', 'groove')

                    var elements = document.querySelectorAll(':hover')
                    var len = elements.length
                    len = len - 1
                    var element = elements[len].__data__
                    var value = element.y1 - element.y0

                    if (element.name === 'metric1') {
                        element.name = chart.y1MetricTooltip
                    } else if (element.name === 'metric2') {
                        element.name = chart.y2MetricTooltip
                    } else if (element.name === 'metric3') {
                        element.name = chart.x1MetricTooltip
                    }

                    y1tip.html(element.name + colonAnnotation + numberFormat(value))
                        .style('left', '50%')
                        .style('top', '30%')
                        .style('display', 'inline-block')
                        .style('opacity', 1)
                })
                .on('mouseout', () => {
                    y1tip.transition().duration(500).style('opacity', 0)
                })*/
        //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

        var bar_enter = bar.selectAll('rect').data(d => {
            return d.values
        }).enter()

        bar_enter.append('rect')
            .attr('height', y1Scale.bandwidth())
            .attr('x', d => {
                return x1Scale(d.y0)
            })
            .attr('width', d => {
                return x1Scale(d.y1) - x1Scale(d.y0)
            })
            .style('fill', d => {
                return metric1ColorScale(d.key)
            })

        bar_enter.append('text')
            .text((d) => {
                return numberFormat(d.y1 - d.y0) + ' '
            })
            .attr('x', (d) => {
                return x1Scale(d.y1) + (x1Scale(d.y0) - x1Scale(d.y1) + 20)
            })
            .attr('y', y1Scale.bandwidth() / 2)
            .style("opacity", (d) => {
                return (d.y1 - d.y0) == 0 ? 0 : 1
            })
            .style('font-size', axislabelfontsize)
            .style('fill', "black")
    // })
}
